import { showToastMessage } from '@/utils';

// Not copyToClipboard: its toast repeats the copied text, and this is the MFA secret.
const copySecret = async (secret: string) => {
  try {
    await navigator.clipboard.writeText(secret);
    showToastMessage('success', 'Key copied');
  } catch {
    showToastMessage('error', 'Could not copy the key');
  }
};

const MfaSecretBox = ({ secret }: { secret: string }) => (
  <>
    <label className="mt-4 block text-sm font-medium text-gray-700">
      Can&apos;t scan? Enter this key manually, time-based, 6 digits
    </label>
    <div className="mt-2 flex items-center gap-2">
      <code className="flex-1 break-all rounded-md border border-green bg-[#F6FFF8] px-3 py-2 text-sm text-black">
        {secret}
      </code>
      <button
        type="button"
        onClick={() => copySecret(secret)}
        className="text-sm text-textcolor underline"
      >
        Copy
      </button>
    </div>
  </>
);

export default MfaSecretBox;
